import React from "react";
import {PageNotFound} from "../components";

const NotFound = () => {
  return (
    <main>
      <PageNotFound />
    </main>
  );
};

export default NotFound;
